import * as _ from 'lodash'
import enums from '../enum';
import util from '../util';
import validator from '../validator';
import jobCostSettingModel from './jobCostSettingModel';
import globalRelay from '../globalRelay';

const scopeOfWorkGroup = enums.jobCostSettingGroups.Scope_Of_Work;

function setting (name, sortIndex, required, jobCost) {
	const item = jobCost.getSetting(scopeOfWorkGroup, name);
	const settingDoc = item ? item.toDocument() : {};

	return _.assign({
		key: util.generateGuid(),
		name: name,
		value: null,
		group: scopeOfWorkGroup
	}, settingDoc, { sortIndex: sortIndex, required: required });
}

function buildItems (jobCost, job, editable) {
	let settings:any[] = [];

	const scopeOfWorkSettings = globalRelay.config!.withVariant(jobCost.companyVariant).jobCostSettings.scopeOfWork

	const itemsKey = scopeOfWorkSettings.itemsKey || 'items'

	if (editable) {
		const items = scopeOfWorkSettings[itemsKey];
		for (let i = 0; i < items.length; i++) {
			const item = items[i];

			if (!item.renoOnly || job.isRenovation) {
				settings.push(setting(item.name, i, !item.optional, jobCost));
			}
		}
	}
	else {
		settings = _.sortBy(_.filter(jobCost.settings, { group: scopeOfWorkGroup }), 'sortIndex');
	}

	return settings;
}

// const _requiredIndices = [0, 1];

class ScopeOfWork {
	_editable;
	_items;
	
	constructor (jobCost, job) {
		this._editable = ['unlocked', 'rejected'].indexOf(jobCost.currentStatus) !== -1;
		this._items = buildItems(jobCost, job, this._editable);
	}
	get isComplete () {
		return _.every(this.items, s => {
			if (s.required || s.value !== null) {
				return !validator.test(s, jobCostSettingModel.rules());
			}
			return true;
		});
	}
	get items () {
		return this._items;
	}
	setValue (key, value) {
		if (!this._editable) {
			return;
		}

		const item = _.find(this.items, { key: key });

		if (item) {
			item.value = value;
		}
	}
	getValue (key) {
		const item = _.find(this.items, { key: key });

		return item && item.value;
	}
	isRequired (key) {
		const item = _.find(this.items, { key: key });

		return !!(item && item.required);
	}
	erase (jobCost) {
		if (!this._editable) {
			return;
		}
		_.forEach(_.filter(jobCost.settings, { group: scopeOfWorkGroup }), item => {
			jobCost.settings.delete(item.key);
		});
	}
	writeTo (jobCost) {
		if (!this._editable) {
			return;
		}

		// clear all of the scope of work settings and re-add them
		this.erase(jobCost);

		_.forEach(_.filter(this.items, item => item.value !== null), item => {
			jobCost.settings.add(item);
		});
	}
}

export default ScopeOfWork;